export default class MemberGroupTypes {
    static modelName = 'MemberGroupTypes';
    id: number
    activ: boolean = true
    groupName: string
    groupDescription: string
    [key: string]: any
}